import { IMediaTypeGroup } from './mediaTypeGroup'
import { IInitAction } from './init'

// Action types
export enum types {
  GET_MEDIA_TYPE_GROUPS__STARTED = 'GET_MEDIA_TYPE_GROUPS__STARTED',
  GET_MEDIA_TYPE_GROUPS__SUCCESS = 'GET_MEDIA_TYPE_GROUPS__SUCCESS',
  GET_MEDIA_TYPE_GROUPS__FAILURE = 'GET_MEDIA_TYPE_GROUPS__FAILURE',
}

export interface IGetMediaTypeGroupsAction {
  type: types.GET_MEDIA_TYPE_GROUPS__STARTED
}

export interface IGetMediaTypeGroupsSuccessAction {
  type: types.GET_MEDIA_TYPE_GROUPS__SUCCESS
  list: IMediaTypeGroup[]
}

export interface IFailureAction {
  type: types.GET_MEDIA_TYPE_GROUPS__FAILURE
  message: string
}

export type MediaTypeGroupsType =
  | IGetMediaTypeGroupsAction
  | IGetMediaTypeGroupsSuccessAction
  | IFailureAction
  | IInitAction

// Reducer types
export interface IMediaTypeGroups {
  isLoading: boolean
  list: IMediaTypeGroup[]
}
